import {
	Button,
	Heading,
	Icon,
	Modal,
	Page,
	Scrollable,
	Sheet,
	TextContainer,
	Card,
	Badge,
} from "@shopify/polaris";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	AlertMinor,
	FlagMajor,
	MobileCancelMajor,
	ChevronDownMinor,
	ChevronRightMinor,
	ListMajor,
	CircleTickOutlineMinor,
} from "@shopify/polaris-icons";
import { configQuickHelp } from "./configQuickHelp";
import "../../css/quickhelp.css";
import { actFecthPlanTable } from "../../actions";
import PlanTable from "../Dashboard/PlanTable";

const QuickHelp = (props) => {
	const [config, setConfig] = useState(configQuickHelp);
	const [modalPlan, setModalPlan] = useState(false);
	const { dataSettings, listPayPalAccounts } = useSelector((state) => state);
	//   console.log(listPayPalAccounts);
	const dispatch = useDispatch();
	const dataStatistical = useSelector((state) => state.dataStatistical);
	const dataAnalys = {
		success:
			Math.ceil(
				(dataStatistical.order_submitted /
					dataStatistical.order_paypal_stripe) *
					10000
			) / 100,
		pending:
			Math.ceil(
				(dataStatistical.order_pending /
					dataStatistical.order_paypal_stripe) *
					10000
			) / 100,

		noTracking:
			Math.ceil(
				(dataStatistical.order_no_tracking /
					dataStatistical.order_paypal_stripe) *
					10000
			) / 100,
		noTransaction:
			Math.ceil(
				(dataStatistical.order_no_transaction_id /
					dataStatistical.order_paypal_stripe) *
					10000
			) / 100,
		unconfirmAcc:
			Math.ceil(
				(dataStatistical.order_unconfirm_account /
					dataStatistical.order_paypal_stripe) *
					10000
			) / 100,
		invalidTrackingNumber:
			Math.ceil(
				(dataStatistical.order_invalid_tracking_number /
					dataStatistical.order_paypal_stripe) *
					10000
			) / 100,
		invalidAccount:
			Math.ceil(
				(dataStatistical.order_invalid_account /
					dataStatistical.order_paypal_stripe) *
					10000
			) / 100,
		overQuota:
			Math.ceil(
				(dataStatistical.order_over_plan /
					dataStatistical.order_paypal_stripe) *
					10000
			) / 100,
	};

	const handleCollapse = (index, status) => {
		const arrayClone = [...config];
		config[index].isActive = !status;
		setConfig(arrayClone);
	};

	const handleContactUs = () => {
		if (typeof window.$crisp != undefined && window.$crisp != undefined) {
			props.closeSheet();
			window.$crisp.push(["do", "chat:open"]);
		}
	};

	const handlePlan = () => {
		props.closeSheet();
		dispatch(actFecthPlanTable(true));
	};

	const getLimit = () => {
		switch (dataSettings.plan) {
			case "free":
				if (dataSettings.marketing_campaign == 1) {
					return "130";
				} else {
					return "30";
				}
			case "basic":
				if (dataSettings.marketing_campaign == 1) {
					return "1,100";
				} else {
					return "1000";
				}
			case "pro":
				if (dataSettings.marketing_campaign == 1) {
					return "6,100";
				} else {
					return "6,000";
				}
			case "pro_plus":
				if (dataSettings.marketing_campaign == 1) {
					return "20,100";
				} else {
					return "20,000";
				}
			case "unlimited":
				return "Unlimited";
			default:
				if (dataSettings.marketing_campaign == 1) {
					return "130";
				} else {
					return "30";
				}
		}
	};

	const getAccountStatus = (payer_id) => {
		return (
			<Badge
				status={payer_id == null ? "critical" : "success"}
				progress="complete"
			>
				Confirmed
			</Badge>
		);
	};

	const overQuotaMarkup = () => (
		<>
			<p>
				Your plan is on <b>{dataSettings.plan}</b>. This plan supports{" "}
				<b>{getLimit()}</b> trackings/month.
			</p>
			<p>
				This month your store has{" "}
				<b>{dataStatistical.all_order_fulfilled}</b> fulfilled orders.
				Therefore, our app sucessfully synced{" "}
				<b>{dataStatistical.order_submitted}</b> for you while{" "}
				<b>{dataStatistical.order_over_plan}</b> orders are not
				supported because of over quota for this subscription.
			</p>
		</>
	);

	const missingPayPalAcc = () => (
		<>
			<p>
				Make sure you are connecting PayPal account:{" "}
				<b>{dataSettings.list_account_missing} </b>
			</p>
		</>
	);

	const quickHelpMarkup = (item) => (
		<div className="quick-help-inner">
			{item.id == "overQuota"
				? overQuotaMarkup()
				: item.content.map((text, index) => (
						<div key={index}>{text}</div>
				  ))}
			{item.solution ? (
				<>
					<div className="quick-help-heading-solution">
						<Heading>
							<Icon
								source={CircleTickOutlineMinor}
								color="success"
							/>
							Solution
						</Heading>
					</div>
					{item.id === "invalidAccount"
						? missingPayPalAcc()
						: item.solution.map((txt, index) => (
								<div key={index}>{txt}</div>
						  ))}
				</>
			) : null}

			{item.solution2?.map((txt2, index) => (
				<div key={index}>
					<div className="quick-help-heading-solution">
						<Heading>
							<Icon
								source={CircleTickOutlineMinor}
								color="success"
							/>
							Solution
						</Heading>
					</div>
					{txt2}
				</div>
			))}

			<div>
				{item.id == "overQuota" ? (
					<Button icon={FlagMajor} onClick={() => setModalPlan(true)}>
						Upgrade now
					</Button>
				) : (
					<Button icon={FlagMajor} onClick={() => handleContactUs()}>
						Contact us
					</Button>
				)}
			</div>
		</div>
	);

	useEffect(() => {}, [dataSettings]);

	return (
		<div>
			<Page narrowWidth>
				<Sheet
					open={props.openSheet}
					onClose={() => props.closeSheet(false)}
					accessibilityLabel="quick-help"
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							height: "100%",
						}}
					>
						<div
							style={{
								alignItems: "center",
								borderBottom: "1px solid #DFE3E8",
								display: "flex",
								justifyContent: "space-between",
								padding: "1rem",
							}}
						>
							<Heading>
								Quick Help - Why your orders sync error?
							</Heading>
							<Button
								accessibilityLabel="Cancel"
								icon={MobileCancelMajor}
								onClick={() => props.closeSheet()}
								plain
							/>
						</div>
						<Scrollable style={{ padding: "1rem", height: "100%" }}>
							<div className="quick-help-container">
								{config.map((item, index) => {
									if (dataAnalys[item.id] > 0) {
										return (
											<div className="mb-3" key={index}>
												<Card sectioned>
													<div className="quick-help-content">
														<div
															className="quick-help-heading"
															onClick={() =>
																handleCollapse(
																	index,
																	item.isActive
																)
															}
														>
															<Heading>
																<Icon
																	source={
																		AlertMinor
																	}
																	color="critical"
																/>
																{item.title}
															</Heading>
															{item.isActive ? (
																<div
																	style={{
																		transition:
																			".5s",
																	}}
																>
																	<Icon
																		source={
																			ChevronDownMinor
																		}
																	/>
																</div>
															) : (
																<div
																	style={{
																		transition:
																			".5s",
																		transform:
																			"rotate(-90deg)",
																	}}
																>
																	<Icon
																		source={
																			ChevronDownMinor
																		}
																	/>
																</div>
															)}
														</div>
														{item.isActive ? (
															<div
																style={{
																	maxHeight:
																		"50rem",
																	transition:
																		".5s",
																	overflow:
																		"hidden",
																}}
															>
																{quickHelpMarkup(
																	item
																)}
															</div>
														) : (
															<div
																style={{
																	maxHeight:
																		"0rem",
																	transition:
																		".5s",
																	overflow:
																		"hidden",
																}}
															>
																{quickHelpMarkup(
																	item
																)}
															</div>
														)}
													</div>
												</Card>
											</div>
										);
									}
								})}
								{configQuickHelp.map((item, index) => {
									if (!(dataAnalys[item.id] > 0)) {
										return (
											<div className="mb-3" key={index}>
												<Card sectioned>
													<div className="quick-help-content">
														<div
															className="quick-help-heading"
															onClick={() =>
																handleCollapse(
																	index,
																	item.isActive
																)
															}
														>
															<Heading>
																<Icon
																	source={
																		ListMajor
																	}
																	color="interactive"
																/>
																{item.title}
															</Heading>
															{!item.isActive ? (
																<div
																	style={{
																		transition:
																			".5s",
																	}}
																>
																	<Icon
																		source={
																			ChevronDownMinor
																		}
																	/>
																</div>
															) : (
																<div
																	style={{
																		transition:
																			".5s",
																		transform:
																			"rotate(-90deg)",
																	}}
																>
																	<Icon
																		source={
																			ChevronDownMinor
																		}
																	/>
																</div>
															)}
														</div>
														{!item.isActive ? (
															<div
																style={{
																	maxHeight:
																		"50rem",
																	transition:
																		".5s",
																	overflow:
																		"hidden",
																}}
															>
																{quickHelpMarkup(
																	item
																)}
															</div>
														) : (
															<div
																style={{
																	maxHeight:
																		"0rem",
																	transition:
																		".5s",
																	overflow:
																		"hidden",
																}}
															>
																{quickHelpMarkup(
																	item
																)}
															</div>
														)}
													</div>
												</Card>
											</div>
										);
									}
								})}
							</div>
						</Scrollable>
						<div
							style={{
								alignItems: "center",
								borderTop: "1px solid #DFE3E8",
								display: "flex",
								justifyContent: "space-between",
								padding: "1rem",
								width: "100%",
							}}
						>
							<Button onClick={() => props.closeSheet()}>
								Close
							</Button>
						</div>
					</div>
				</Sheet>
			</Page>
			<Modal
				large={true}
				open={modalPlan}
				onClose={() => setModalPlan(false)}
				title="Pricing Table"
				secondaryActions={[
					{
						content: "Cancel",
						onAction: () => setModalPlan(false),
					},
				]}
			>
				<Modal.Section>
					<PlanTable type="step" />
				</Modal.Section>
			</Modal>
		</div>
	);
};

export default QuickHelp;
